var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.location
    ? _c("div", [
        _c("div", {
          staticStyle: { width: "234px", height: "232px" },
          attrs: { id: "map" },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }